import React from 'react';
import { Select } from 'antd';
import { SelectContainer } from 'shared/styles';
import { VrUser, VrUserInternal } from 'shared/types';

type User = VrUser | VrUserInternal;

type Props = {
  value: string[];
  handleUserChange: (userIds: string[]) => void;
  disabled: boolean;
  hideAllUsers?: boolean;
  users: User[];
};

const UserSelect: React.FC<Props> = ({
  value,
  handleUserChange,
  disabled,
  users,
}): JSX.Element => {
  const sortedUsers = [...users].sort((a, b) => {
    const getLabel = (user: User) =>
      user.firstName || user.lastName
        ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
        : user.email;

    return getLabel(a).localeCompare(getLabel(b), undefined, {
      sensitivity: 'base',
    });
  });

  return (
    <SelectContainer>
      <Select
        style={{ width: '100%' }}
        mode="multiple"
        onChange={handleUserChange}
        placeholder="All users (default)"
        disabled={disabled}
        allowClear
        value={value}
        optionFilterProp="label"
        options={sortedUsers.map(user => {
          const label =
            user.firstName || user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.email;

          return {
            value: user.id,
            label,
          };
        })}
      />
    </SelectContainer>
  );
};

export default UserSelect;
